import { ChangeEvent } from 'react'
import { Search } from 'lucide-react'
import { cn } from '@utils/cn'

interface PageHeroProps {
  readonly title: string
  readonly secondaryLabel?: string
  readonly searchPlaceholder?: string
  readonly searchValue?: string
  readonly onSearchChange?: (value: string) => void
  readonly className?: string
}

export function PageHero({
  title,
  secondaryLabel,
  searchPlaceholder,
  searchValue,
  onSearchChange,
  className,
}: Readonly<PageHeroProps>) {
  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    onSearchChange?.(event.target.value)
  }

  const showSearch = typeof onSearchChange === 'function'

  return (
    <div
      className={cn(
        'flex flex-col gap-3 md:gap-4 rounded-2xl md:rounded-[32px] bg-[#17253C] px-4 py-4 md:px-6 md:py-6 text-white shadow-xl md:flex-row md:items-center md:justify-between lg:px-10 lg:py-8',
        className
      )}
    >
      <h1 className="text-sm md:text-3xl font-bold uppercase tracking-[0.2em] md:tracking-[0.35em]">{title}</h1>

      <div className="flex w-full flex-col gap-3 md:w-auto md:flex-row md:items-center md:gap-4">
        {showSearch && (
          <div className="relative w-full md:w-72">
            <Search className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-white/70" />
            <input
              value={searchValue ?? ''}
              onChange={handleSearchChange}
              placeholder={searchPlaceholder}
              className="w-full rounded-full border border-white/20 bg-white/10 py-2 pl-12 pr-4 text-xs md:text-sm font-medium text-white placeholder:text-white/60 focus:border-white focus:outline-none focus:ring-2 focus:ring-white/70"
            />
          </div>
        )}
        {secondaryLabel && (
          <span className="inline-flex items-center justify-center rounded-full border border-white/30 px-6 py-2 text-xs font-semibold uppercase tracking-[0.32em]">
            {secondaryLabel}
          </span>
        )}
      </div>
    </div>
  )
}


